import Cookies from 'js-cookie'

export const scrollTopInCookie = () => {
  Cookies.set('scroll', JSON.stringify({
    'top': {
      'document': $(document).scrollTop()
    }
  }));
}
